import styled from 'styled-components';

interface StyledTitleProps {
  $textColor?: string;
}

const StyledTitle = styled.h1<StyledTitleProps>`
  color: ${props => props.$textColor || '#000000'};
`

export default StyledTitle;